
function productdisplayer(artnrs, targ, disptpe){
    if(artnrs && targ && disptpe){
        if(disptpe == 'productslider'){
            productdisplayer_productslider(artnrs, targ);
        } else if(disptpe == 'productsmall'){
            /* Will follow */
        } else {
            console.log('Displaytype not recognized');
        }
    } else {
        console.log('Not all productdisplayer parameters are set');
    }
}

function productdisplayer_target(targ){
    let $productdisp_targelem = $(targ);
    let productdisp_targelem_lng = $productdisp_targelem.length;
    if(productdisp_targelem_lng == 1){
        return $productdisp_targelem;
    } else if(productdisp_targelem_lng == 0){
        console.log('Displaytarget not found');
        return false;
    } else {
        console.log('Multiple displaytargets found - can only be 1');
        return false;
    }
}

function productdisplayer_preppath(artnrs){
    if(artnrs.length > 0){
        let retpreppath = '';
        $.each(artnrs, function(index,artnrsItem){
            retpreppathpart = artnrsItem.replaceAll('/', '-');
            retpreppath += retpreppathpart + '_';
        });
        return retpreppath;
    } else {
        console.log('No artnrs set');
        return false;
    }
}

function productdisplayer_productslider(artnrs, targ){
    /* target check */
    let productdisp_artpath = productdisplayer_preppath(artnrs);
    let $productdisp_targ = productdisplayer_target(targ);
    if(productdisp_artpath && $productdisp_targ){
        productdisplayer_productslider_render(productdisp_artpath, $productdisp_targ);
    }
}
async function productdisplayer_productslider_render(dispsldpath, $dispsldtarg) {
    let productdisp_slider_url = main_globlang_pref + '/pages/contact/' + dispsldpath + '/?sections=display-productslider';
    let productdisp_sliderRender = await fetch(productdisp_slider_url)
    .then(response => response.json())
    .then(data => { 
        $dispsldtarg.html(data["display-productslider"]);
    });
}

function productdisplayer_productsmall(artnrs, targ){
    /* WILL FOLLOW */
    console.log('This displaytype will be available soon');
}